import { Checkbox, Form, Modal, Button } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import React from 'react'

const CompanyWorkScheduleConfirmSendNotificaitonModal = ({
  visible,
  onConfirm,
  onCancel,
  isLoading,
}) => {
  const [form] = Form.useForm()

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
      footer={null}
      title={null}
      closable={false}
      width={480}
      bodyStyle={{ padding: 0 }}
      wrapClassName="update-event-modal"
    >
      <style>{`
        .update-event-modal .ant-modal-content {
          border-radius: 16px;
          background: #e8f0fe;
          overflow: hidden;
        }
      `}</style>
      <div style={{ padding: '24px 24px 24px 32px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 22, fontWeight: 600, color: '#202124' }}>Cập nhật lịch công tác</div>
          <CloseOutlined onClick={onCancel} style={{ cursor: 'pointer', color: '#5f6368', fontSize: 18 }} />
        </div>

        <div style={{ background: '#fff', borderRadius: 16, padding: '24px 32px' }}>
          <p style={{ marginBottom: 16, fontSize: 15, color: '#3c4043' }}>Bạn có muốn cập nhật lịch công tác này không?</p>
          <Form form={form} onFinish={onConfirm}>
            <Form.Item
              name="is_notification_required"
              initialValue={true}
              valuePropName="checked"
              style={{ marginBottom: 32 }}>
              <Checkbox style={{ fontSize: 15 }}>Gửi thông báo</Checkbox>
            </Form.Item>
            
            <div style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
              <Button size="large" onClick={onCancel} style={{ borderRadius: 6, minWidth: 140 }}>
                Hủy
              </Button>
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                loading={isLoading}
                style={{ borderRadius: 6, minWidth: 140 }}>
                Xác nhận
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </Modal>
  )
}

export default CompanyWorkScheduleConfirmSendNotificaitonModal
